// extracted by mini-css-extract-plugin
export default {"container":"SocietyHomepageServices_container__B2c7Y","content":"SocietyHomepageServices_content__sNhEa"};